import * as texto from './texto'
import * as numeros from './numeros'



export function getDataAtual(br=true, com_horario=false){

    const hoje = new Date()

    const dia = hoje.getDate().toString().padStart(2,'0')
    const mes = String(hoje.getMonth() + 1).padStart(2,'0')
    const ano = hoje.getFullYear()
    
    return br?dia+"/"+mes+"/"+ano:ano+"-"+mes+"-"+dia+
			(com_horario?" "+hoje.getHours()+":"+hoje.getMinutes()+":"+hoje.getSeconds():"");
}


export function converteDataEuaParaBr(data, ignorar_horario=true){

	data = numeros.formatarSomenteNum(data);

    if(texto.isBlanck(data))
		return "";

    return data.substring(6, 8)+"/"+data.substring(4, 6)+"/"+data.substring(0, 4)+
		(!ignorar_horario && data.length>=12?" "+data.substring(8, 10)+":"+data.substring(10, 12):"")
}


export function converteDataBrParaEua(data){

	data = numeros.formatarSomenteNum(data);

    if(texto.isBlanck(data))
		return "";

    if(data.length!=8)
        return "";

    return data.substring(4)+"-"+data.substring(2, 4)+"-"+data.substring(0, 2);
}


export function compararDatas(data1, data2) {
   
	console.log(data1+" "+data2)
   
    const d1 = new Date(data1);
    const d2 = new Date(data2);

    return (d1 < d2)?-1:(d1 == d2)?0:1;
}


export function getMesAtual(){

    return new Date().getMonth() + 1;
}


export function getAnoAtual(){

    return new Date().getFullYear();
}
